(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7130],{

/***/ 46441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopyOutlined');

/***/ }),

/***/ 30677:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'DialpadOutlined');

/***/ }),

/***/ 95502:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M13.25 16.74c0 .69-.53 1.26-1.25 1.26-.7 0-1.26-.56-1.26-1.26 0-.71.56-1.25 1.26-1.25.71 0 1.25.55 1.25 1.25M11.99 6c-1.77 0-2.98 1.15-3.43 2.49l1.64.69c.22-.67.74-1.48 1.8-1.48 1.62 0 1.94 1.52 1.37 2.33-.54.77-1.47 1.29-1.96 2.16-.39.69-.31 1.49-.31 1.98h1.82c0-.93.07-1.12.22-1.41.39-.72 1.11-1.06 1.87-2.17.68-1 .42-2.36-.02-3.08-.51-.84-1.52-1.51-3-1.51M19 5H5v14h14zm0-2c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2z"
}), 'HelpCenterOutlined');

/***/ }),

/***/ 12192:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m0 14H4v-6h16zm0-10H4V6h16z"
}), 'PaymentOutlined');

/***/ }),

/***/ 59744:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17 10h-4.59l.58-3.41v-.2c-.01-.26-.12-.51-.3-.7L12 5l-4.6 5c-.27.26-.42.62-.4 1v5c0 1.1.9 2 2 2h5.5c.56.03 1.08-.29 1.3-.8l2.1-4.9c.08-.15.12-.33.1-.5V11c0-.55-.45-1-1-1"
}, "1")], 'RecommendOutlined');

/***/ }),

/***/ 12802:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-storage/[...location]",
      function () {
        return __webpack_require__(13625);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78868:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/chevron-down.e5a5a334.svg","height":20,"width":20});

/***/ }),

/***/ 83664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CanonicalURL; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utility__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55088);




function CanonicalURL() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: (0,_utility__WEBPACK_IMPORTED_MODULE_3__/* .getCanonicalURL */ .DN)(router)
        })
    });
}


/***/ }),

/***/ 41165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

var tConvert = function(time) {
    var timeCal = (time === null || time === void 0 ? void 0 : time.toString().match(/^(0?[0-9]|1[0-9]|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/)) || [
        time
    ];
    if ((timeCal === null || timeCal === void 0 ? void 0 : timeCal.length) > 1) {
        var myMoment = moment__WEBPACK_IMPORTED_MODULE_0___default()(time, "HH:mm");
        var minutesFormat = myMoment === null || myMoment === void 0 ? void 0 : myMoment.format("h:mma");
        if (minutesFormat === null || minutesFormat === void 0 ? void 0 : minutesFormat.includes("00")) {
            return myMoment === null || myMoment === void 0 ? void 0 : myMoment.format("ha");
        }
        return minutesFormat;
    }
    return time === null || time === void 0 ? void 0 : time.join("");
};
// eslint-disable-next-line consistent-return
var convertTimeFormat = function(value, locale, text) {
    if (!value && locale === "fr") return "Ferm\xe9";
    if (!value) return "Closed";
    if (value === "Open 24 hours") {
        return locale === "en" ? "Open 24 hours" : "24 h/24";
    }
    var trimSpace = value.replace(/\s/g, "");
    var hoursSplit = trimSpace.split("-");
    if (hoursSplit.length !== 2) {
        return value;
    }
    var openTime = hoursSplit[0].split(":")[0].length > 1 ? hoursSplit[0].replace(/^0?/, "") : hoursSplit[0];
    var closeTime = hoursSplit[1].split(":")[0].length > 1 ? hoursSplit[1].replace(/^0?/, "") : hoursSplit[1];
    // 9 h 18 h
    if (locale === "fr") {
        if (openTime === null || openTime === void 0 ? void 0 : openTime.includes(":00")) openTime = openTime === null || openTime === void 0 ? void 0 : openTime.split(":")[0];
        if (closeTime === null || closeTime === void 0 ? void 0 : closeTime.includes(":00")) closeTime = closeTime === null || closeTime === void 0 ? void 0 : closeTime.split(":")[0];
        return "".concat(openTime, " h \xe0 ").concat(closeTime, " h");
    }
    var localeTime = "".concat(tConvert(openTime), " - ").concat(tConvert(closeTime));
    if (text) {
        return "".concat(text, " ").concat(localeTime);
    }
    return localeTime;
};
/* harmony default export */ __webpack_exports__["Z"] = (convertTimeFormat);


/***/ }),

/***/ 66115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/context/HeaderFooterContext.tsx
var HeaderFooterContext = __webpack_require__(2621);
;// CONCATENATED MODULE: ./public/images/error_404.png
/* harmony default export */ var error_404 = ({"src":"/_next/static/media/error_404.f1ddc8fc.png","height":351,"width":392,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAVFBMVEVMaXHT1NPPy8vq6uquqaq/v8C4tLTFs7Xp6ure397ayMrg19jv8vKem5zMysrExMTV1dTAwMDBxMTKfobHkJbLvb7s8fHs7u2zmJvIyMjY2Njd3d2qQk9TAAAAG3RSTlMAhbb5W24qFtOZ4vV/e2L6yk02bsTX155CeeRf4oh3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nCXGSRKAIAwEwGFNIiLKoiL//yel9qmBNSyMF23RfgEl9ycP5Q6PAqsVPztq074bM3Cy0H2JTCzDAdsSyHf/AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./src/services/home/setBrands.ts
var setBrands = __webpack_require__(76784);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
;// CONCATENATED MODULE: ./src/pages/404.tsx












var PageNotFound = function() {
    var locale = (0,router.useRouter)().locale;
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var isContext = !!headerFooter[0];
    var getContextData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var defaultBrand, contextData, brands;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = constants/* BRAND_NAME_EN */.Vp;
                        if (locale === "fr") defaultBrand = constants/* BRAND_NAME_FR */.Fj;
                        return [
                            4,
                            (0,setBrands/* default */.Z)(defaultBrand, locale)
                        ];
                    case 1:
                        contextData = _state.sent();
                        brands = contextData === null || contextData === void 0 ? void 0 : contextData.data;
                        headerFooterData.setHeaderFooterData(brands);
                        return [
                            2
                        ];
                }
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "sv-page-content error-page",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-6 col-md-9 col-sm-12 mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "error-brief",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "error-img",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    sizes: "(max-width: 375px) 220px, (max-width: 576px) 395px, (max-width: 768px) 400px, (max-width: 992px) 400px, (max-width: 1280px) 400px",
                                    src: error_404,
                                    alt: "404",
                                    className: "img-fluid",
                                    height: "300",
                                    width: "300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "error-heading",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "pnf-msg"
                                    }),
                                    "!"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "para",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "pnf-desc"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/self-storage",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "btn sv-primary-red-btn",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "pnf-find"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var _404 = (PageNotFound);


/***/ }),

/***/ 13625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _location_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./src/components/client-hub/api.tsx


var headers = new Headers({
    "Content-Type": "application/json",
    Accept: "application/json"
});
var clientHubTrack = function(body) {
    var env = window.location.href.includes("accessstorage.ca") ? "production" : "staging";
    var apiUrl = env === "production" ? "https://datavault-express.storagevaultcanada.com/clientHub/track" : "https://datavault-express-stg.storagevaultcanada.com/clientHub/track";
    fetch(apiUrl, {
        headers: headers,
        method: "POST",
        body: JSON.stringify(body)
    }).catch(function(err) {
        // eslint-disable-next-line no-console
        console.error("Tracking request failed:", err);
    });
};
var clientHubContact = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var env, apiUrl, response, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    env = window.location.href.includes("accessstorage.ca") ? "production" : "staging";
                    apiUrl = env === "production" ? "https://datavault-express.storagevaultcanada.com/clientHub/contact/new" : "https://datavault-express-stg.storagevaultcanada.com/clientHub/contact/new";
                    return [
                        4,
                        fetch(apiUrl, {
                            headers: headers,
                            method: "POST",
                            body: JSON.stringify(body)
                        })
                    ];
                case 1:
                    response = _state.sent();
                    _tmp = {
                        ok: response.ok,
                        status: response.status
                    };
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.body = _state.sent(), _tmp)
                    ];
            }
        });
    });
    return function clientHubContact(body) {
        return _ref.apply(this, arguments);
    };
}();
var clientHubRefer = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(body) {
        var env, apiUrl, response, _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    env = window.location.href.includes("accessstorage.ca") ? "production" : "staging";
                    apiUrl = env === "production" ? "https://datavault-express.storagevaultcanada.com/clientHub/referral/new" : "https://datavault-express-stg.storagevaultcanada.com/clientHub/referral/new";
                    return [
                        4,
                        fetch(apiUrl, {
                            headers: headers,
                            method: "POST",
                            body: JSON.stringify(body)
                        }).catch(function(error) {
                            return {
                                ok: false,
                                status: 500,
                                json: function() {
                                    return "Error: ".concat(error);
                                }
                            };
                        })
                    ];
                case 1:
                    response = _state.sent();
                    _tmp = {
                        ok: response.ok,
                        status: response.status
                    };
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.body = _state.sent(), _tmp)
                    ];
            }
        });
    });
    return function clientHubRefer(body) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/DialpadOutlined.js
var DialpadOutlined = __webpack_require__(30677);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/HelpCenterOutlined.js
var HelpCenterOutlined = __webpack_require__(95502);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocalPhoneOutlined.js
var LocalPhoneOutlined = __webpack_require__(8987);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PaymentOutlined.js
var PaymentOutlined = __webpack_require__(12192);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/RecommendOutlined.js
var RecommendOutlined = __webpack_require__(59744);
;// CONCATENATED MODULE: ./src/components/client-hub/mobile-footer.tsx








var ClientHubMobileFooter = function(props) {
    var scrollTo = props.scrollTo, activeSection = props.activeSection, hasGate = props.hasGate;
    var menuItemStaticStyle = {
        height: "80px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: hasGate ? "20%" : "25%"
    };
    var menuIconStyle = {
        height: "48px",
        lineHeight: "60px",
        fontSize: "50px"
    };
    var menuItemColor = {
        selected: "rgba(240, 248, 255, 1)",
        default: "rgba(240, 248, 255, 0.5)"
    };
    var menuItemDynamicStyle = function(itemId) {
        return {
            backgroundColor: activeSection === itemId ? menuItemColor.selected : menuItemColor.default,
            boxShadow: activeSection === itemId ? "lightblue 0px 0px 24px -16px inset" : undefined
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "mobile-footer",
        className: "fixed-bottom",
        style: {
            height: "80px",
            backgroundColor: "white",
            opacity: 1,
            zIndex: 999
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                height: "80px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return scrollTo("contact");
                    },
                    style: (0,_object_spread/* default */.Z)({}, menuItemStaticStyle, menuItemDynamicStyle("contact")),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: menuIconStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalPhoneOutlined/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Contact"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return scrollTo("payment");
                    },
                    style: (0,_object_spread/* default */.Z)({}, menuItemStaticStyle, menuItemDynamicStyle("payment")),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: menuIconStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentOutlined/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Payments"
                        })
                    ]
                }),
                hasGate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return scrollTo("access");
                    },
                    style: (0,_object_spread/* default */.Z)({}, menuItemStaticStyle, menuItemDynamicStyle("access")),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: menuIconStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DialpadOutlined/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Access"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return scrollTo("referral");
                    },
                    style: (0,_object_spread/* default */.Z)({}, menuItemStaticStyle, menuItemDynamicStyle("referral")),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: menuIconStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendOutlined/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Referrals"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    onClick: function() {
                        return scrollTo("faq");
                    },
                    style: (0,_object_spread/* default */.Z)({}, menuItemStaticStyle, menuItemDynamicStyle("faq")),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: menuIconStyle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpCenterOutlined/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "FAQs"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var mobile_footer = (ClientHubMobileFooter);

;// CONCATENATED MODULE: ./src/components/client-hub/sections/access.tsx
/* eslint-disable */ 

var customKeypadInstructions = {
    l097: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Please use your fob to disarm the alarm before entering your unit, and to re-arm when you exit."
    }),
    l174: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "At the keypad, enter: ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                children: "unit number # code *"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "For example, if your unit number is 12345 and your access code is 6789, you would enter: 12345#6789*",
            " "
        ]
    }),
    l176: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "At the keypad, enter: ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                children: "unit number # code *"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "For example, if your unit number is 12345 and your access code is 6789, you would enter: 12345#6789*",
            " "
        ]
    }),
    l267: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "At the keypad, enter your access code followed by the key symbol on the keypad",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "For example, if your access code is 1234, you would enter: 1234 and then press the key symbol",
            " "
        ]
    }),
    l289: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "To access the building, tap your access pass on the black card reader."
    })
};
var facilitiesThatUseFob = [
    "L097",
    "L289"
];
var ClientHubAccess = function(props) {
    var ref;
    var isMobile = props.isMobile, scrollTo = props.scrollTo, activeSection = props.activeSection, track = props.track, facilityData = props.facilityData, sitelinkId = props.sitelinkId;
    var id = "access";
    var hasAccessCode = true;
    var facilityId = facilityData === null || facilityData === void 0 ? void 0 : facilityData.Facility_ID;
    if (facilityId && facilitiesThatUseFob.includes(facilityId)) {
        hasAccessCode = false;
    }
    var facilityIdLowercase = (facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.Facility_ID) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || "";
    var hasCustomInstructions = Object.keys(customKeypadInstructions).includes(facilityIdLowercase);
    var showSection = function() {
        if (isMobile) return activeSection === id;
        return true;
    };
    var getCustomKeypadInstructions = function() {
        if (hasCustomInstructions) {
            return customKeypadInstructions[facilityIdLowercase];
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: showSection() ? "block" : "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                id: "access",
                style: {
                    textTransform: "none",
                    backgroundColor: "aliceblue"
                },
                children: [
                    "Unit access ",
                    hasAccessCode && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: " & access code "
                    })
                ]
            }),
            hasAccessCode && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    "You must use your personal access code for both entry and exit."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    hasAccessCode && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "How to find your access code"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "- Log in to",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        style: {
                                            textDecoration: "none"
                                        },
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: function() {
                                            return track("Open MyAccount");
                                        },
                                        href: "https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=".concat(sitelinkId, "==&1=1"),
                                        children: "My Account"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "- Select your unit ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    '- The access code will appear below your contact information on the "Account Balance" page ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "- Or call us for assistance ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "Accessing your unit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Gate hours can be found in the",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "#",
                                onClick: function(e) {
                                    e.preventDefault();
                                    scrollTo("contact");
                                    return false;
                                },
                                style: {
                                    textDecoration: "none"
                                },
                                children: "Contact"
                            }),
                            " ",
                            "section. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            hasCustomInstructions && getCustomKeypadInstructions(),
                            !hasCustomInstructions && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    "At the keypad, enter: ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "*code#"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "For example, if your access code is 12345, you would enter: *12345#",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    });
};
/* harmony default export */ var access = (ClientHubAccess);

// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 10 modules
var Button = __webpack_require__(13850);
;// CONCATENATED MODULE: ./src/components/client-hub/InstallPWAButton.tsx



 // Assuming Material UI is installed

var InstallPWAButton = function() {
    var ref = (0,react.useState)(null), deferredPrompt = ref[0], setDeferredPrompt = ref[1];
    var ref1 = (0,react.useState)(false), isAppInstalled = ref1[0], setIsAppInstalled = ref1[1];
    var ref2 = (0,react.useState)("other"), platform = ref2[0], setPlatform = ref2[1];
    var ref3 = (0,react.useState)(false), showInstructions = ref3[0], setShowInstructions = ref3[1];
    var ref4 = (0,react.useState)(""), instructionMessage = ref4[0], setInstructionMessage = ref4[1];
    // Check if running in standalone mode or PWA is already installed & platform
    (0,react.useEffect)(function() {
        if (true) {
            if (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true) {
                setIsAppInstalled(true);
            } else {
                console.log("[InstallPWAButton] App is not in standalone mode.");
            }
            var ua = window.navigator.userAgent.toLowerCase();
            var isIosDevice = /iphone|ipad|ipod/.test(ua) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1 && !window.MSStream;
            if (isIosDevice) {
                console.log("[InstallPWAButton] Platform detected: iOS");
                setPlatform("ios");
            } else if (/android/.test(ua)) {
                console.log("[InstallPWAButton] Platform detected: Android");
                setPlatform("android");
            } else {
                console.log("[InstallPWAButton] Platform detected: Other");
                setPlatform("other");
            }
        }
    }, []);
    // Listener for 'beforeinstallprompt' event
    (0,react.useEffect)(function() {
        if (true) {
            if (isAppInstalled) {
                return;
            }
            if (platform === "ios") {
                return;
            }
            if (platform === "android" || platform === "other") {
                // Listen on Android and 'other' just in case
                var handler = function(e) {
                    e.preventDefault();
                    setDeferredPrompt(e); // <<<< THE FIX
                };
                window.addEventListener("beforeinstallprompt", handler);
            }
        }
    }, [
        isAppInstalled,
        platform
    ]);
    var handleInstallClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var outcome, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShowInstructions(true); // Always show the instruction panel on click, initially
                        if (platform === "ios") {
                            setInstructionMessage('To install on your iOS device:\n1. Tap the "Share" icon in your browser.\n2. Scroll down and tap "Add to Home Screen".');
                            return [
                                2
                            ];
                        }
                        if (!(deferredPrompt && platform === "android")) return [
                            3,
                            5
                        ];
                        deferredPrompt.prompt();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            deferredPrompt.userChoice
                        ];
                    case 2:
                        outcome = _state.sent().outcome;
                        if (outcome === "accepted") {
                            setIsAppInstalled(true);
                            setShowInstructions(false);
                        } else {
                            setInstructionMessage('Installation cancelled.\nTo install manually:\n1. Tap the menu (⋮) in your browser.\n2. Tap "Install app" or "Add to Home screen".');
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setInstructionMessage('If installation did not start:\n1. Tap the menu (⋮) in your browser.\n2. Tap "Install app" or "Add to Home screen".');
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setDeferredPrompt(null); // The prompt can only be used once
                        return [
                            3,
                            6
                        ];
                    case 5:
                        if (platform === "android" && !deferredPrompt) {
                            setInstructionMessage('To install this app:\n1. Tap the menu (⋮) in your browser.\n2. Look for "Install app" or "Add to Home Screen".');
                        } else if (platform === "other") {
                            // '[InstallPWAButton] Platform is "Other", showing generic instructions.'
                            setInstructionMessage('To add this app to your home screen, please look for an "Add to Home Screen" or "Install" option in your browser\'s menu.');
                        }
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleInstallClick() {
            return _ref.apply(this, arguments);
        };
    }();
    if (isAppInstalled) {
        return null;
    }
    var canAttemptInstall = platform === "ios" || platform === "android" || platform === "other" && deferredPrompt;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "contained",
                style: {
                    backgroundColor: "#E2002D",
                    marginBottom: 12,
                    color: "white"
                },
                onClick: handleInstallClick,
                disabled: !canAttemptInstall,
                children: "Add to Home Screen"
            }),
            showInstructions && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    marginTop: 12,
                    padding: 12,
                    background: "#f9f9f9",
                    border: "1px solid #ccc",
                    borderRadius: 4,
                    maxWidth: 300,
                    textAlign: "left"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: "0.9rem",
                            whiteSpace: "pre-line"
                        },
                        children: instructionMessage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        size: "small",
                        style: {
                            marginTop: 12,
                            backgroundColor: "#bbb",
                            color: "#fff"
                        },
                        onClick: function() {
                            return setShowInstructions(false);
                        },
                        children: "Got it"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var client_hub_InstallPWAButton = (InstallPWAButton);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ContentCopyOutlined.js
var ContentCopyOutlined = __webpack_require__(46441);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/components/referral/style.module.scss
var style_module = __webpack_require__(39076);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
;// CONCATENATED MODULE: ./src/components/client-hub/sections/contact-webform.tsx











var inputStyle = {
    width: "100%",
    marginBottom: "10px",
    boxSizing: "border-box",
    background: "rgba(224, 225, 227, 0.14)",
    border: "1px solid rgba(2, 35, 94, 0.2)",
    borderRadius: "4px"
};
var ClientHubContactWebform = function(props) {
    var ref, ref1, ref2, ref3;
    var track = props.track;
    var facilityId = props.facilityId;
    var locale = "en";
    var ref4 = (0,react.useState)(""), caseId = ref4[0], setCaseId = ref4[1];
    var ref5 = (0,react.useState)(""), fullName = ref5[0], setFullName = ref5[1];
    var ref6 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            fullName: "",
            email: "",
            phone: null,
            message: ""
        }
    }), register = ref6.register, getValues = ref6.getValues, reset = ref6.reset, trigger = ref6.trigger, errors = ref6.formState.errors;
    var formSubmissionLock = false;
    var clickSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, formIsValid, body, response, ref1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (formSubmissionLock === true) {
                            return [
                                2
                            ];
                        }
                        formSubmissionLock = true;
                        track("Submit contact web form");
                        return [
                            4,
                            trigger()
                        ];
                    case 1:
                        formIsValid = _state.sent();
                        if (!formIsValid) {
                            console.log("Errors found", errors);
                            return [
                                2
                            ];
                        }
                        body = {
                            lcode: facilityId,
                            fullName: getValues("fullName"),
                            phone: getValues("phone"),
                            email: getValues("email"),
                            message: getValues("message")
                        };
                        return [
                            4,
                            clientHubContact(body)
                        ];
                    case 2:
                        response = _state.sent();
                        // TODO handle API errors
                        if ((ref = response.body) === null || ref === void 0 ? void 0 : ref.caseId) {
                            ;
                            setCaseId((ref1 = response.body) === null || ref1 === void 0 ? void 0 : ref1.caseId);
                            setFullName(body.fullName);
                            formSubmissionLock = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function clickSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var resetForm = function() {
        reset();
        setCaseId("");
    };
    var copyToClipboard = function(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }
        var textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "absolute";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        return new Promise(function(resolve, reject) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            document.execCommand("copy") ? resolve(true) : reject();
            textArea.remove();
        });
    };
    var copyCaseId = function() {
        return copyToClipboard("Client care ticket id: ".concat(caseId));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                action: "",
                method: "POST",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (style_module_default()).formLabel,
                                                children: "Full name*"
                                            }, "name"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        type: "text",
                                                        style: inputStyle
                                                    }, register("fullName", {
                                                        required: locale === "en" ? constants/* NAME_FORM_ERR */.J1 : constants/* NAME_FORM_ERR_FR */.Fw,
                                                        pattern: {
                                                            value: /^[a-zA-Z\s]{0,50}$/,
                                                            message: locale === "en" ? constants/* ENTER_CHARS_FORM_ERR */.GK : constants/* NAME_FORM_ERR_FR */.Fw
                                                        }
                                                    }))),
                                                    ((ref = errors.fullName) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "error-msg text-end",
                                                        children: (ref1 = errors.fullName) === null || ref1 === void 0 ? void 0 : ref1.message
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: " Phone number on file*"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        type: "tel",
                                                        id: "phone",
                                                        style: inputStyle
                                                    }, register("phone", {
                                                        required: "Phone is required",
                                                        pattern: {
                                                            value: /^(?![01])[0-9]{10}$/,
                                                            message: locale === "en" ? constants/* FORM_ERRORS.EN.ENTER_PHONE */.W_.EN.ENTER_PHONE : constants/* FORM_ERRORS.FR.PHONE */.W_.FR.PHONE
                                                        }
                                                    }))),
                                                    ((ref2 = errors.phone) === null || ref2 === void 0 ? void 0 : ref2.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "error-msg text-end",
                                                        children: (ref3 = errors.phone) === null || ref3 === void 0 ? void 0 : ref3.message
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: " Email"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                            type: "email",
                                            id: "email",
                                            style: inputStyle
                                        }, register("email", {
                                            required: false,
                                            pattern: {
                                                value: /^$|^\S+@\S+$/i,
                                                message: locale === "en" ? constants/* ENTER_VALID_FORM_ERR */.P_ : constants/* EMAIL_FORM_ERR_FR */.hh
                                            }
                                        })))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: " Message*"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread/* default */.Z)({
                                                    id: "message",
                                                    rows: 5,
                                                    style: inputStyle
                                                }, register("message", {
                                                    required: "Message is required"
                                                })))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "center",
                                margin: "10px 0"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                style: {
                                    backgroundColor: "#E2002D",
                                    marginBottom: 12,
                                    color: "white"
                                },
                                onClick: function() {
                                    return clickSubmit();
                                },
                                children: "Submit"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "success-modal",
                style: {
                    display: caseId ? "flex" : "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "lightgrey",
                            opacity: "0.5",
                            zIndex: 2000
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            position: "fixed",
                            zIndex: 3000
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                width: "80%",
                                minHeight: "10em",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                padding: "20px",
                                opacity: "1"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    style: {
                                        textTransform: "none"
                                    },
                                    children: "Thank you for reaching out!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        "We have received your message ",
                                        fullName.trim().split(" ")[0],
                                        ", and one of our team members will give you a call shortly."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                children: [
                                                    "Client care ticket id: ",
                                                    caseId
                                                ]
                                            })
                                        }),
                                        " ",
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function() {
                                                return copyCaseId();
                                            },
                                            style: {
                                                cursor: "pointer"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCopyOutlined/* default */.Z, {
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        "We’ve got you in queue and will reach out directly.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Talk soon, and thank you for your patience."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            cursor: "pointer",
                                            border: "2px solid lightgrey",
                                            borderRadius: "5px",
                                            padding: "8px 16px"
                                        },
                                        onClick: function() {
                                            resetForm();
                                        },
                                        children: "Close"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var contact_webform = (ClientHubContactWebform);

// EXTERNAL MODULE: ./src/helper/convertTimeFormat.tsx
var convertTimeFormat = __webpack_require__(41165);
// EXTERNAL MODULE: ./public/images/icons/chevron-down.svg
var chevron_down = __webpack_require__(78868);
;// CONCATENATED MODULE: ./src/components/client-hub/sections/contact.tsx






var ClientHubContact = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var isMobile = props.isMobile, activeSection = props.activeSection, track = props.track, facilityData = props.facilityData;
    var id = "contact";
    var Address = facilityData === null || facilityData === void 0 ? void 0 : facilityData.Address;
    var ref8 = (0,react.useState)(false), expandOfficeHours = ref8[0], setExpandOfficeHours = ref8[1];
    var officeHours = function(dayOfWeek) {
        return (0,convertTimeFormat/* default */.Z)(facilityData.Store_Hours[dayOfWeek], "en");
    };
    var ref9 = (0,react.useState)(false), expandGateHours = ref9[0], setExpandGateHours = ref9[1];
    var gateHours = function(dayOfWeek) {
        return (0,convertTimeFormat/* default */.Z)(facilityData.Open_Hours[dayOfWeek], "en");
    };
    var showSection = function() {
        if (isMobile) return activeSection === id;
        return true;
    };
    var ref10 = (0,react.useState)(false), showWebForm = ref10[0], setShowWebForm = ref10[1];
    var toggleWebForm = function() {
        if (!showWebForm) track("Expand contact web form");
        setShowWebForm(!showWebForm);
    };
    if (!facilityData) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: showSection() ? "block" : "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    marginBottom: "30px"
                },
                children: [
                    "We are excited to welcome you to",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                        children: [
                            "Access Storage – ",
                            (facilityData === null || facilityData === void 0 ? void 0 : facilityData.Title) || ""
                        ]
                    }),
                    ". Here you can find everything you need to get started."
                ]
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginBottom: "30px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: function() {
                        return track("Install app");
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(client_hub_InstallPWAButton, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                id: "contact",
                style: {
                    textTransform: "none",
                    backgroundColor: "aliceblue"
                },
                children: "Contact us"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "We are here to support you at every step.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                            children: [
                                "By phone:",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    style: {
                                        textDecoration: "none"
                                    },
                                    onClick: function() {
                                        return track("Call store");
                                    },
                                    href: "tel:".concat(facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.Support) === null || ref === void 0 ? void 0 : ref.Phone_Number),
                                    children: facilityData === null || facilityData === void 0 ? void 0 : (ref1 = facilityData.Support) === null || ref1 === void 0 ? void 0 : ref1.Phone_Number
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            return toggleWebForm();
                        },
                        style: {
                            padding: "20px 0 10px 0"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                            children: [
                                "By",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    style: {
                                        textDecoration: "none"
                                    },
                                    onClick: function(e) {
                                        e.preventDefault();
                                        return false;
                                    },
                                    href: "#",
                                    children: [
                                        " ",
                                        "web form"
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: chevron_down/* default.src */.Z.src,
                                    style: {
                                        transform: showWebForm ? "rotateX(180deg)" : "",
                                        filter: "invert(44%) sepia(71%) saturate(5305%) hue-rotate(183deg) brightness(99%) contrast(101%)"
                                    },
                                    alt: "chevron-down"
                                })
                            ]
                        })
                    }),
                    showWebForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_webform, {
                            track: track,
                            facilityId: facilityData === null || facilityData === void 0 ? void 0 : facilityData.Facility_ID
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "Address:"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        style: {
                                            textDecoration: "none"
                                        },
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: function() {
                                            return track("Open store directions");
                                        },
                                        href: "https://www.google.com/maps/search/?api=1&query=%20&query_place_id=".concat(facilityData === null || facilityData === void 0 ? void 0 : facilityData.Google_PlaceID),
                                        children: [
                                            " ",
                                            Address === null || Address === void 0 ? void 0 : Address.Street_1,
                                            Address === null || Address === void 0 ? void 0 : Address.Street_2,
                                            ", ",
                                            Address === null || Address === void 0 ? void 0 : Address.City,
                                            " ",
                                            Address === null || Address === void 0 ? void 0 : Address.Postal_Code
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    paddingTop: "10px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                        children: "Website:"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        style: {
                                            textDecoration: "none"
                                        },
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: function() {
                                            return track("Open store page");
                                        },
                                        href: "https://www.accessstorage.ca/en/self-storage/".concat((facilityData === null || facilityData === void 0 ? void 0 : (ref2 = facilityData.City) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.attributes) === null || ref4 === void 0 ? void 0 : ref4.Slug) ? "".concat(facilityData === null || facilityData === void 0 ? void 0 : (ref5 = facilityData.City) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.attributes) === null || ref7 === void 0 ? void 0 : ref7.Slug, "/") : "", "/").concat(facilityData === null || facilityData === void 0 ? void 0 : facilityData.Slug, "/"),
                                        children: [
                                            "Access Storage – ",
                                            (facilityData === null || facilityData === void 0 ? void 0 : facilityData.Title) || ""
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return setExpandOfficeHours(!expandOfficeHours);
                                },
                                style: {
                                    paddingTop: "10px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                    children: [
                                        " ",
                                        "Office hours",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: chevron_down/* default.src */.Z.src,
                                            style: {
                                                transform: expandOfficeHours ? "rotateX(180deg)" : ""
                                            },
                                            alt: "chevron-down"
                                        }),
                                        " "
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: expandOfficeHours ? "block" : "none",
                                    paddingLeft: "10px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Monday: ",
                                            officeHours("Monday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Tuesday: ",
                                            officeHours("Tuesday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Wednesday: ",
                                            officeHours("Wednesday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Thursday: ",
                                            officeHours("Thursday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Friday: ",
                                            officeHours("Friday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Saturday: ",
                                            officeHours("Saturday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Sunday: ",
                                            officeHours("Sunday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                onClick: function() {
                                    return setExpandGateHours(!expandGateHours);
                                },
                                style: {
                                    paddingTop: "10px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                    children: [
                                        " ",
                                        "Gate hours",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: chevron_down/* default.src */.Z.src,
                                            style: {
                                                transform: expandGateHours ? "rotateX(180deg)" : ""
                                            },
                                            alt: "chevron-down"
                                        }),
                                        " "
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: expandGateHours ? "block" : "none",
                                    paddingLeft: "10px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Monday: ",
                                            gateHours("Monday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Tuesday: ",
                                            gateHours("Tuesday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Wednesday: ",
                                            gateHours("Wednesday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Thursday: ",
                                            gateHours("Thursday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Friday: ",
                                            gateHours("Friday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Saturday: ",
                                            gateHours("Saturday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            "Sunday: ",
                                            gateHours("Sunday")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    });
};
/* harmony default export */ var contact = (ClientHubContact);

;// CONCATENATED MODULE: ./src/components/client-hub/sections/faq.tsx



var ClientHubFaq = function(props) {
    var isMobile = props.isMobile, activeSection = props.activeSection, track = props.track, scrollTo = props.scrollTo, sitelinkId = props.sitelinkId;
    var id = "faq";
    var showSection = function() {
        if (isMobile) return activeSection === id;
        return true;
    };
    var ref = (0,react.useState)(false), expandReferrals = ref[0], setExpandReferrals = ref[1];
    var ref1 = (0,react.useState)(false), expandAccessMyUnit = ref1[0], setExpandAccessMyUnit = ref1[1];
    var ref2 = (0,react.useState)(false), expandStorageTips = ref2[0], setExpandStorageTips = ref2[1];
    var ref3 = (0,react.useState)(false), expandItemsUnsafeToStore = ref3[0], setExpandItemsUnsafeToStore = ref3[1];
    var ref4 = (0,react.useState)(false), expandProtectionPlan = ref4[0], setExpandProtectionPlan = ref4[1];
    var ref5 = (0,react.useState)(false), expandMultipleCharges = ref5[0], setExpandMultipleCharges = ref5[1];
    var ref6 = (0,react.useState)(false), expandLatePayment = ref6[0], setExpandLatePayment = ref6[1];
    var ref7 = (0,react.useState)(false), expandMovingOut = ref7[0], setExpandMovingOut = ref7[1];
    var ref8 = (0,react.useState)(false), expandFaqMultipleUnits = ref8[0], setExpandFaqMultipleUnits = ref8[1];
    var ref9 = (0,react.useState)(false), expandFullTermsOfService = ref9[0], setExpandFullTermsOfService = ref9[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: showSection() ? "block" : "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                id: "faq",
                style: {
                    textTransform: "none",
                    backgroundColor: "aliceblue"
                },
                children: "FAQs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandReferrals(!expandReferrals);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        " ",
                        "Does Access Storage have a referral program?",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandReferrals ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: expandReferrals ? "block" : "none"
                },
                children: [
                    "Yes! Send someone our way and get up to $100 through our referral program. It pays to be a good friend! ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Eligibility: both current and past clients are eligible to participate."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Once your friend or family member moves into the unit you will be contacted to receive your reward."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Rewards will be issued by prepaid credit card after the referral has moved into the unit and submitted all required documentation."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    "Reward amount: ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                        border: 1,
                                        cellPadding: 6,
                                        cellSpacing: 0,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            style: {
                                                                minWidth: "4em"
                                                            },
                                                            children: "Amount"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "Unit size"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: "50$"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: "0-100 sq ft & Outdoor Parking"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: "75$"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: "101-250 sq ft"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: "100$"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                children: "Larger than 250 sq ft"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        children: "*Restrictions may apply."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandAccessMyUnit(!expandAccessMyUnit);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        " ",
                        "When may I access my unit?",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandAccessMyUnit ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: expandAccessMyUnit ? "block" : "none"
                },
                children: [
                    "Access and/or gate hours can be found in the",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "#",
                        onClick: function(e) {
                            e.preventDefault();
                            scrollTo("contact");
                            return false;
                        },
                        style: {
                            textDecoration: "none"
                        },
                        children: "Contact"
                    }),
                    " ",
                    "section.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandStorageTips(!expandStorageTips);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        " ",
                        "How should I store my items?",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandStorageTips ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: expandStorageTips ? "block" : "none"
                },
                children: [
                    "Here are some best practices to help you store with confidence:",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Label your boxes clearly to make items easy to find."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Cover mattresses and soft goods with plastic to protect from dust and moisture, but do not seal them air-tight. Always leave an opening for air to circulate."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Keep your unit secure! Never share your access code or key."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Make an inventory list and store it in a safe place for easy reference."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Keep items off the floor, when possible, by using pallets or protective mats."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandItemsUnsafeToStore(!expandItemsUnsafeToStore);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        " ",
                        "Are there any items that I ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                            children: "can't"
                        }),
                        " put in storage?",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandItemsUnsafeToStore ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: expandItemsUnsafeToStore ? "block" : "none"
                },
                children: [
                    "All food and edible items are strictly prohibited. Including, but not limited to, boxed, canned or perishable food items, pet food, and spices. These items can attract pests. By avoiding these in storage, we all help maintain a clean, pest-free environment.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "For your safety and compliance, storing the following items is prohibited:",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Living or organic items, such as plants/seeds, soil/fertilizer, pets or humans! (Please don’t sleep or stay in your unit for extended periods of time.)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Anything requiring power or your long-term presence inside the unit."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Items that may leak or cause damage to your unit or others. If storing a vehicle, ground covering is recommended."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Flammable, toxic, or hazardous materials, such as gas, propane, or chemicals."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Illegal items, including weapons, drugs, or stolen goods."
                            })
                        ]
                    }),
                    "Violating these rules may result in immediate termination of your User Agreement.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandProtectionPlan(!expandProtectionPlan);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        " ",
                        "What is the 'Protection Plan' all about?",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandProtectionPlan ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: expandProtectionPlan ? "block" : "none"
                },
                children: [
                    "Peace of mind comes standard! ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "All unit rentals include automatic enrollment in our Protection Plan. This plan may include limited protection for risks like fire, theft, and certain types of water damage. If you have your own insurance, simply share proof with us to opt out. Protection limits range from $2,500 to $5,000 ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Claims must be submitted promptly with documentation and photographs. This plan is not a replacement for personal home or renter’s insurance.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Review full details here:",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            textDecoration: "none"
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: function() {
                            return track("Open terms of service");
                        },
                        href: "https://tripemco.com/TripemcoSelfStorageWordings/TenantsWordingsLong.pdf#page=4",
                        children: "Terms of Service"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandMultipleCharges(!expandMultipleCharges);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        "Why do I see multiple rent charges on my invoice?",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandMultipleCharges ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: expandMultipleCharges ? "block" : "none"
                },
                children: [
                    "Your account is billed every 4 weeks from your move-in date. You may see upcoming rent cycles listed on your statement or in your online account — this is normal and meant for visibility. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "We can also pro-rate your rent by the week if you will not use the unit for the entire cycle. Please contact us before the next due date to organize your payment. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Important: You only need to pay for your current billing cycle. Any",
                    " ",
                    "future rent charges shown are not yet due. If you'd like to pay ahead,",
                    " ",
                    "you're welcome to — but it's not required.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandLatePayment(!expandLatePayment);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        "What happens if I'm late making a payment?",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandLatePayment ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: expandLatePayment ? "block" : "none"
                },
                children: [
                    "The best way to keep your account current is to enroll in pre-authorized payment. You can sign up via our secure client portal:",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            textDecoration: "none"
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: function() {
                            return track("Open MyAccount");
                        },
                        href: "https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=".concat(sitelinkId, "==&1=1"),
                        children: "My Account"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                        border: 1,
                        cellPadding: 6,
                        cellSpacing: 0,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            style: {
                                                minWidth: "4em"
                                            },
                                            children: "Day"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: "Action"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 3"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "A late fee of 5% (minimum $5) is added to the account."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 5"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Access is temporarily paused to the unit and the property."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 9"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "An additional late fee of 5% (minimum $5) is added to the account."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 15"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "An additional late fee of 5% (minimum $5) is added to the account."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 21"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "An additional late fee of 5% (minimum $5) is added to the account."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 31"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                children: [
                                                    "We begin auction preparation by photographing the unit",
                                                    " ",
                                                    "contents. If payment is made after this point, you'll just need to replace the lock."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 45"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "A lien fee equal to one rent cycle will be added, and you’ll need to pay the full balance before the auction date to retain your unit."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "Day 90"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                children: "If no payment has occurred, the unit is considered abandoned and the unit contents will be auctioned."
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandMovingOut(!expandMovingOut);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        " ",
                        "What do I need to do when I’m moving out?",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandMovingOut ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: expandMovingOut ? "block" : "none"
                },
                children: [
                    "Your rental is fully flexible! ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "If you only need the unit for part of your next cycle, just let us know before the start of the next billing cycle. We’ll gladly assist you with a one-time, pro-rated rent payment. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Refunds are available only if you’ve moved out before the rental’s due date. Please take all items with you at move-out, remove the lock from your unit and notify our Team once you’re done. A disposal fee of $50 to $500 will apply if items are left behind after move-out. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandFaqMultipleUnits(!expandFaqMultipleUnits);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        " ",
                        "What if I have more than one unit?",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandFaqMultipleUnits ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: expandFaqMultipleUnits ? "block" : "none"
                },
                children: [
                    "If you have more than one unit with us, you can see and manage all your units in one place. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Visit our secure client portal:",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            textDecoration: "none"
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: function() {
                            return track("Open MyAccount");
                        },
                        href: "https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=".concat(sitelinkId, "==&1=1"),
                        children: "My Account"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Once logged in:",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "A list of all your units will be available."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Select one of your units"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "From this point forward, follow the same steps outlined in the Payments and/or Access section"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: function() {
                    return setExpandFullTermsOfService(!expandFullTermsOfService);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                    children: [
                        " ",
                        "Full terms of service",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: chevron_down/* default.src */.Z.src,
                            style: {
                                transform: expandFullTermsOfService ? "rotateX(180deg)" : ""
                            },
                            alt: "chevron-down"
                        }),
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: expandFullTermsOfService ? "block" : "none"
                },
                children: [
                    "While we take every precaution to maintain a safe and secure environment, we encourage you to review your User Agreement terms for details on responsibility and coverage.",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            textDecoration: "none"
                        },
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: function() {
                            return track("Open terms of service");
                        },
                        href: "https://www.accessstorage.ca/en/terms-of-service/",
                        children: "Terms of Service"
                    }),
                    ".",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
        ]
    });
};
/* harmony default export */ var faq = (ClientHubFaq);

;// CONCATENATED MODULE: ./src/components/client-hub/sections/payment.tsx


var ClientHubPayment = function(props) {
    var isMobile = props.isMobile, activeSection = props.activeSection, track = props.track, sitelinkId = props.sitelinkId, storePhone = props.storePhone;
    var id = "payment";
    var showSection = function() {
        if (isMobile) return activeSection === id;
        return true;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: showSection() ? "block" : "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                id: "payment",
                style: {
                    textTransform: "none",
                    backgroundColor: "aliceblue"
                },
                children: "Payments"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    "Accounts are billed on a 4-week cycle from your move-in date. You only need to pay the current cycle. For more information, please see the FAQs section. ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "Pay online"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Visit our secure client portal:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                style: {
                                    textDecoration: "none"
                                },
                                target: "_blank",
                                rel: "noreferrer",
                                onClick: function() {
                                    return track("Open MyAccount");
                                },
                                href: "https://www.smdservers.net/SLWebSiteTemplate_V2/login.aspx?sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=".concat(sitelinkId, "==&1=1"),
                                children: "My Account"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Once logged in: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    paddingLeft: "10px",
                                    display: "block"
                                },
                                children: "1. Select your unit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    paddingLeft: "10px",
                                    display: "block"
                                },
                                children: '2. Go to "Make a Payment" to pay by credit card or direct debit'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "Pay by phone"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Call us at",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                style: {
                                    textDecoration: "none"
                                },
                                onClick: function() {
                                    return track("Call store");
                                },
                                href: "tel:".concat(storePhone),
                                children: storePhone
                            }),
                            " ",
                            "and we’ll help process your payment. ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    });
};
/* harmony default export */ var payment = (ClientHubPayment);

;// CONCATENATED MODULE: ./src/components/client-hub/sections/referral.tsx











var ClientHubReferral = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var isMobile = props.isMobile, activeSection = props.activeSection, track = props.track, lcode = props.lcode;
    var locale = "en";
    var id = "referral";
    var showSection = function() {
        if (isMobile) return activeSection === id;
        return true;
    };
    var ref10 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            clientFullName: "",
            clientEmail: "",
            clientPhone: null,
            friendRelationship: "",
            friendName: "",
            friendEmail: "",
            friendPhone: null
        }
    }), register = ref10.register, getValues = ref10.getValues, reset = ref10.reset, trigger = ref10.trigger, errors = ref10.formState.errors;
    var ref11 = (0,react.useState)(""), formDisplayed = ref11[0], setFormDisplayed = ref11[1];
    var ref12 = (0,react.useState)(""), caseId = ref12[0], setCaseId = ref12[1];
    var ref13 = (0,react.useState)(""), clientName = ref13[0], setClientName = ref13[1];
    var ref14 = (0,react.useState)(""), recipientName = ref14[0], setRecipientName = ref14[1];
    var formSubmissionLock = false;
    var clickRefer = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var formIsValid, body, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (formSubmissionLock === true) {
                            return [
                                2
                            ];
                        }
                        formSubmissionLock = true;
                        track("Click Refer");
                        return [
                            4,
                            trigger()
                        ];
                    case 1:
                        formIsValid = _state.sent();
                        if (!formIsValid) {
                            console.log("Errors found", errors);
                            return [
                                2
                            ];
                        }
                        body = {
                            lcode: lcode,
                            client: {
                                fullName: getValues("clientFullName"),
                                phone: getValues("clientPhone"),
                                email: getValues("clientEmail")
                            },
                            friend: {
                                relationship: getValues("friendRelationship"),
                                name: getValues("friendName"),
                                phone: getValues("friendPhone"),
                                email: getValues("friendEmail")
                            },
                            isAlreadyReferred: formDisplayed === "received"
                        };
                        return [
                            4,
                            clientHubRefer(body)
                        ];
                    case 2:
                        response = _state.sent();
                        // TODO handle API errors
                        if (response.status === 200) {
                            setCaseId("true");
                            formSubmissionLock = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function clickRefer() {
            return _ref.apply(this, arguments);
        };
    }();
    var resetForm = function() {
        reset();
        setClientName("");
        setRecipientName("");
        setCaseId("");
    };
    var copyToClipboard = function(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }
        var textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "absolute";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        return new Promise(function(resolve, reject) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            document.execCommand("copy") ? resolve(true) : reject();
            textArea.remove();
        });
    };
    var copyCaseId = function() {
        return copyToClipboard("Referral id: ".concat(caseId));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            display: showSection() ? "block" : "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "success-modal",
                style: {
                    display: caseId ? "flex" : "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "lightgrey",
                            opacity: "0.5",
                            zIndex: 2000
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            position: "fixed",
                            zIndex: 3000
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                width: "80%",
                                minHeight: "10em",
                                backgroundColor: "white",
                                borderRadius: "10px",
                                padding: "20px",
                                opacity: "1"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    style: {
                                        textTransform: "none"
                                    },
                                    children: formDisplayed === "send" ? "Thank you for your referral!" : "Thank you for your letting us know!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: formDisplayed === "send" ? "We'll reach out to you once ".concat(recipientName, " has moved in.") : "We'll confirm your information and process the referral."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "none"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                                        children: [
                                                            "Referral id: ",
                                                            caseId
                                                        ]
                                                    })
                                                }),
                                                " ",
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    onClick: function() {
                                                        return copyCaseId();
                                                    },
                                                    style: {
                                                        cursor: "pointer"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCopyOutlined/* default */.Z, {
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                "Submitted by: ",
                                                clientName
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                "Recipient: ",
                                                recipientName
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Talk soon!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            cursor: "pointer",
                                            border: "2px solid lightgrey",
                                            borderRadius: "5px",
                                            padding: "8px 16px"
                                        },
                                        onClick: function() {
                                            resetForm();
                                        },
                                        children: "Close"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                id: "referral",
                style: {
                    textTransform: "none",
                    backgroundColor: "aliceblue"
                },
                children: "Referrals"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    " ",
                    "Refer a friend to Access Storage and ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "earn up to $100"
                    }),
                    " when they move in. Just fill in the form below."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "20px 0"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            padding: "10px",
                            margin: "0 10px",
                            textAlign: "center",
                            width: "50%",
                            backgroundColor: formDisplayed === "send" ? "rgba(240, 248, 255)" : "rgba(240, 248, 255, 0.5)",
                            boxShadow: formDisplayed === "send" ? "lightblue 0px 0px 24px -16px inset" : "",
                            borderBottom: formDisplayed === "send" ? "2px solid lightblue" : ""
                        },
                        onClick: function() {
                            return setFormDisplayed(formDisplayed === "send" ? "" : "send");
                        },
                        children: [
                            "Send a referral",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            padding: "10px",
                            margin: "0 10px",
                            textAlign: "center",
                            width: "50%",
                            backgroundColor: formDisplayed === "received" ? "rgba(240, 248, 255)" : "rgba(240, 248, 255, 0.5)",
                            boxShadow: formDisplayed === "received" ? "lightblue 0px 0px 24px -16px inset" : "",
                            borderBottom: formDisplayed === "received" ? "2px solid lightblue" : ""
                        },
                        onClick: function() {
                            return setFormDisplayed(formDisplayed === "received" ? "" : "received");
                        },
                        children: [
                            "I was referred",
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px 0"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                style: {
                    display: formDisplayed === "" ? "none" : ""
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: "Your contact information"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: (style_module_default()).formLabel,
                                                children: "Full name*"
                                            }, "name"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        type: "text",
                                                        style: {
                                                            width: "100%",
                                                            marginBottom: "10px",
                                                            boxSizing: "border-box",
                                                            background: "rgba(224, 225, 227, 0.14)",
                                                            border: "1px solid rgba(2, 35, 94, 0.2)",
                                                            borderRadius: "4px"
                                                        }
                                                    }, register("clientFullName", {
                                                        required: locale === "en" ? constants/* NAME_FORM_ERR */.J1 : constants/* NAME_FORM_ERR_FR */.Fw,
                                                        pattern: {
                                                            value: /^[a-zA-Z\s]{0,50}$/,
                                                            message: locale === "en" ? constants/* ENTER_CHARS_FORM_ERR */.GK : constants/* NAME_FORM_ERR_FR */.Fw
                                                        }
                                                    }))),
                                                    ((ref = errors.clientFullName) === null || ref === void 0 ? void 0 : ref.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "error-msg text-end",
                                                        children: (ref1 = errors.clientFullName) === null || ref1 === void 0 ? void 0 : ref1.message
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                children: " Phone number on file*"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                        type: "tel",
                                                        id: "phone",
                                                        style: {
                                                            width: "100%",
                                                            marginBottom: "10px",
                                                            boxSizing: "border-box",
                                                            background: "rgba(224, 225, 227, 0.14)",
                                                            border: "1px solid rgba(2, 35, 94, 0.2)",
                                                            borderRadius: "4px"
                                                        }
                                                    }, register("clientPhone", {
                                                        required: "Phone is required",
                                                        pattern: {
                                                            value: /^(?![01])[0-9]{10}$/,
                                                            message: locale === "en" ? constants/* FORM_ERRORS.EN.ENTER_PHONE */.W_.EN.ENTER_PHONE : constants/* FORM_ERRORS.FR.PHONE */.W_.FR.PHONE
                                                        }
                                                    }))),
                                                    ((ref2 = errors.clientPhone) === null || ref2 === void 0 ? void 0 : ref2.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "error-msg text-end",
                                                        children: (ref3 = errors.clientPhone) === null || ref3 === void 0 ? void 0 : ref3.message
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: " Email"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                            type: "email",
                                            id: "email",
                                            style: {
                                                width: "100%",
                                                marginBottom: "10px",
                                                boxSizing: "border-box",
                                                background: "rgba(224, 225, 227, 0.14)",
                                                border: "1px solid rgba(2, 35, 94, 0.2)",
                                                borderRadius: "4px"
                                            }
                                        }, register("clientEmail", {
                                            required: false,
                                            pattern: {
                                                value: /^$|^\S+@\S+$/i,
                                                message: locale === "en" ? constants/* ENTER_VALID_FORM_ERR */.P_ : constants/* EMAIL_FORM_ERR_FR */.hh
                                            }
                                        })))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: formDisplayed === "send" ? "The referral information" : "The information of the person who referred you"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (style_module_default()).formRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: (style_module_default()).formLabel,
                                            children: "Relationship to you (friend, coworker, etc)*"
                                        }, "name"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                    type: "text",
                                                    style: {
                                                        width: "100%",
                                                        marginBottom: "10px",
                                                        boxSizing: "border-box",
                                                        background: "rgba(224, 225, 227, 0.14)",
                                                        border: "1px solid rgba(2, 35, 94, 0.2)",
                                                        borderRadius: "4px"
                                                    }
                                                }, register("friendRelationship", {
                                                    required: "Relationship required"
                                                }))),
                                                ((ref4 = errors.friendRelationship) === null || ref4 === void 0 ? void 0 : ref4.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "error-msg text-end",
                                                    children: (ref5 = errors.friendRelationship) === null || ref5 === void 0 ? void 0 : ref5.message
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (style_module_default()).formRow,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: (style_module_default()).formLabel,
                                            children: "Name*"
                                        }, "name"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                    type: "text",
                                                    style: {
                                                        width: "100%",
                                                        marginBottom: "10px",
                                                        boxSizing: "border-box",
                                                        background: "rgba(224, 225, 227, 0.14)",
                                                        border: "1px solid rgba(2, 35, 94, 0.2)",
                                                        borderRadius: "4px"
                                                    }
                                                }, register("friendName", {
                                                    required: "Name is required",
                                                    pattern: {
                                                        value: /^[a-zA-Z\s]{0,50}$/,
                                                        message: locale === "en" ? constants/* ENTER_CHARS_FORM_ERR */.GK : constants/* NAME_FORM_ERR_FR */.Fw
                                                    }
                                                }))),
                                                ((ref6 = errors.friendName) === null || ref6 === void 0 ? void 0 : ref6.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "error-msg text-end",
                                                    children: (ref7 = errors.friendName) === null || ref7 === void 0 ? void 0 : ref7.message
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: " Phone number*"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                    type: "tel",
                                                    id: "phone",
                                                    style: {
                                                        width: "100%",
                                                        marginBottom: "10px",
                                                        boxSizing: "border-box",
                                                        background: "rgba(224, 225, 227, 0.14)",
                                                        border: "1px solid rgba(2, 35, 94, 0.2)",
                                                        borderRadius: "4px"
                                                    }
                                                }, register("friendPhone", {
                                                    required: "Phone is required",
                                                    pattern: {
                                                        value: /^(?![01])[0-9]{10}$/,
                                                        message: locale === "en" ? constants/* FORM_ERRORS.EN.ENTER_PHONE */.W_.EN.ENTER_PHONE : constants/* FORM_ERRORS.FR.PHONE */.W_.FR.PHONE
                                                    }
                                                }))),
                                                ((ref8 = errors.friendPhone) === null || ref8 === void 0 ? void 0 : ref8.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "error-msg text-end",
                                                    children: (ref9 = errors.friendPhone) === null || ref9 === void 0 ? void 0 : ref9.message
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            children: " Email"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                                                type: "email",
                                                id: "email",
                                                style: {
                                                    width: "100%",
                                                    marginBottom: "10px",
                                                    boxSizing: "border-box",
                                                    background: "rgba(224, 225, 227, 0.14)",
                                                    border: "1px solid rgba(2, 35, 94, 0.2)",
                                                    borderRadius: "4px"
                                                }
                                            }, register("friendEmail", {
                                                required: false,
                                                pattern: {
                                                    value: /^$|^\S+@\S+$/i,
                                                    message: locale === "en" ? constants/* ENTER_VALID_FORM_ERR */.P_ : constants/* EMAIL_FORM_ERR_FR */.hh
                                                }
                                            })))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        margin: "10px 0"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            fontSize: "small"
                                        },
                                        children: "By submitting a referral I confirm I agree with the referral program terms in the FAQs section."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        margin: "10px 0"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "contained",
                                        style: {
                                            backgroundColor: "#E2002D",
                                            marginBottom: 12,
                                            color: "white"
                                        },
                                        onClick: function() {
                                            return clickRefer();
                                        },
                                        children: formDisplayed === "send" ? "Refer" : "Submit"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    });
};
/* harmony default export */ var referral = (ClientHubReferral);

// EXTERNAL MODULE: ./src/components/common/Canonical.tsx
var Canonical = __webpack_require__(83664);
;// CONCATENATED MODULE: ./src/utils/intercom.ts
var intercomLog = function(message) {
    if (!window.intercomLog || window.intercomLog.length >= 100) window.intercomLog = [];
    window.intercomLog.push("".concat(new Date().toLocaleTimeString(), " - ").concat(message));
};
var handleIntercom = function() {
    intercomLog("openIntercom started");
    window.intercomFirstMessage = false;
    var userAgent = navigator.userAgent.toLowerCase();
    var isMobile = /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent);
    var isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent);
    // The interval is used to await Intercom
    var interval = setInterval(function() {
        if (typeof window.Intercom === "undefined") {
            intercomLog("Interval: Intercom not defined");
            return;
        }
        intercomLog("Interval: Intercom is defined");
        // When opening the chat for the first time in this session skip showing the "message list"
        window.Intercom("onShow", function() {
            if (!window.intercomFirstMessage) {
                window.intercomFirstMessage = true;
                window.Intercom("showNewMessage");
            }
        });
        // If the user is on desktop, pop the chat open on page load
        if (!isMobile && !isTablet) {
        // window.Intercom('show');
        }
        clearInterval(interval);
    }, 2000);
};

;// CONCATENATED MODULE: ./src/components/client-hub/index.tsx












var facilitiesWithoutGate = [
    "L015b",
    "L223a"
];
var ClientHub = function(param) {
    var facilityData = param.facilityData;
    var ref;
    var pageVisitLogged = (0,react.useRef)(false);
    var interval = (0,react.useRef)(undefined);
    var hideNavRef = (0,react.useRef)(undefined);
    var ref1 = (0,react.useState)(true), isMobile = ref1[0], setIsMobile = ref1[1];
    var ref2 = (0,react.useState)("contact"), activeSection = ref2[0], setActiveSection = ref2[1];
    var ref3 = (0,react.useState)(false), showStoreId = ref3[0], setShowStoreId = ref3[1];
    var hasGate = true;
    if ((facilityData === null || facilityData === void 0 ? void 0 : facilityData.Facility_ID) && facilitiesWithoutGate.includes(facilityData === null || facilityData === void 0 ? void 0 : facilityData.Facility_ID)) {
        hasGate = false;
    }
    var scrollTo = function(elementId) {
        if (isMobile) {
            setActiveSection(elementId);
        } else {
            var element = document.getElementById(elementId);
            window.scrollTo({
                top: element.offsetTop - 90,
                left: element.offsetLeft,
                behavior: "smooth"
            });
        }
    };
    var setWebsiteFooter = function(deviceIsMobile) {
        var footerElements = document.getElementsByTagName("footer");
        if (footerElements.length) {
            var footer = footerElements[0];
            footer.style.display = deviceIsMobile ? "none" : "block";
        }
    };
    var setDisplayNone = function(el) {
        var ref;
        if (typeof (el === null || el === void 0 ? void 0 : (ref = el.style) === null || ref === void 0 ? void 0 : ref.display) !== "string") return;
        // eslint-disable-next-line no-param-reassign
        el.style.display = "none";
    };
    var hideIntercom = function() {
        if (interval.current) return;
        interval.current = setInterval(function() {
            if (typeof window.Intercom !== "undefined") {
                intercomLog("Interval: Intercom is defined - Hide");
                window.Intercom("hide");
                setDisplayNone(document.getElementsByClassName("intercom-app")[0]);
                setDisplayNone(document.getElementsByClassName("intercom-lightweight-app")[0]);
            } else {
                intercomLog("Interval: Intercom not defined");
            }
        }, 1000);
    };
    var track = function(event) {
        // eslint-disable-next-line no-console
        console.log("Tracking: ".concat(event));
        if (event === "Page visit") {
            pageVisitLogged.current = true;
        }
        var body = {
            userAgent: navigator.userAgent || "",
            isMobile: isMobile,
            event: event,
            url: window.location.href || "",
            guid: "none",
            isNewVisitor: true,
            dateOfFirstVisit: "".concat(new Date()),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
            timezoneOffset: String(new Date().getTimezoneOffset()),
            screenWidth: String(window.innerWidth),
            screenHeight: String(window.innerHeight)
        };
        clientHubTrack(body);
    };
    var setDeviceType = function() {
        var ua = window.navigator.userAgent.toLowerCase();
        var deviceIsMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1 && !window.MSStream; // MacIntel for iPadOS
        setWebsiteFooter(deviceIsMobile);
        setIsMobile(deviceIsMobile);
    };
    // useEffect(() => {
    //   if ('serviceWorker' in navigator) {
    //     // register/sw.js must live at /sw.js in production
    //     window.addEventListener('load', () => {
    //       navigator.serviceWorker
    //         .register('/sw.js')
    //         .then((reg) => {
    //           console.log('ServiceWorker registered, scope:', reg.scope);
    //         })
    //         .catch((err) => {
    //           console.error('ServiceWorker registration failed:', err);
    //         });
    //     });
    //   }
    // }, []);
    (0,react.useEffect)(function() {
        setDeviceType();
        hideIntercom();
        if (pageVisitLogged.current === false) {
            track("Page visit");
        }
    }, []);
    (0,react.useEffect)(function() {
        var hideTopRightSideNav = function() {
            if (hideNavRef.current) {
                clearInterval(hideNavRef.current);
            }
            hideNavRef.current = setInterval(function() {
                var rightSideNavElements = document.getElementsByClassName("rightSide-nav");
                if (rightSideNavElements.length) {
                    var rightSideNav = rightSideNavElements[0];
                    rightSideNav.style.display = "none";
                }
            }, 500);
        };
        hideTopRightSideNav();
        return function() {
            if (hideNavRef.current) {
                clearInterval(hideNavRef.current);
                hideNavRef.current = undefined;
            }
        };
    }, []);
    (0,react.useEffect)(function() {
        var handleKeyPress = function(event) {
            if (event.shiftKey && event.key.toUpperCase() === "L") {
                setShowStoreId(function(prev) {
                    return !prev;
                });
            }
        };
        // Add event listener on mount
        window.addEventListener("keydown", handleKeyPress);
        // Cleanup the event listener on unmount
        return function() {
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Access Storage"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/apple-touch-icon.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Canonical/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row justify-content-center g-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    children: [
                                        "Client Hub",
                                        "  ",
                                        showStoreId && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            style: {
                                                color: "lightgrey"
                                            },
                                            children: [
                                                "\xa0",
                                                facilityData === null || facilityData === void 0 ? void 0 : facilityData.Facility_ID
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contact, {
                                isMobile: isMobile,
                                activeSection: activeSection,
                                track: track,
                                facilityData: facilityData
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(payment, {
                                isMobile: isMobile,
                                activeSection: activeSection,
                                track: track,
                                sitelinkId: facilityData === null || facilityData === void 0 ? void 0 : facilityData.Sitelink_URL_ID,
                                storePhone: facilityData === null || facilityData === void 0 ? void 0 : (ref = facilityData.Support) === null || ref === void 0 ? void 0 : ref.Phone_Number
                            }),
                            hasGate && /*#__PURE__*/ (0,jsx_runtime.jsx)(access, {
                                isMobile: isMobile,
                                scrollTo: scrollTo,
                                activeSection: activeSection,
                                track: track,
                                facilityData: facilityData,
                                sitelinkId: facilityData === null || facilityData === void 0 ? void 0 : facilityData.Sitelink_URL_ID
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(referral, {
                                isMobile: isMobile,
                                activeSection: activeSection,
                                track: track,
                                lcode: facilityData === null || facilityData === void 0 ? void 0 : facilityData.Facility_ID
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(faq, {
                                isMobile: isMobile,
                                activeSection: activeSection,
                                track: track,
                                scrollTo: scrollTo,
                                sitelinkId: facilityData === null || facilityData === void 0 ? void 0 : facilityData.Sitelink_URL_ID
                            }),
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_footer, {
                                scrollTo: scrollTo,
                                activeSection: activeSection,
                                hasGate: hasGate
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var client_hub = (ClientHub);

// EXTERNAL MODULE: ./src/context/HeaderFooterContext.tsx
var HeaderFooterContext = __webpack_require__(2621);
// EXTERNAL MODULE: ./src/services/home/index.ts
var home = __webpack_require__(66156);
// EXTERNAL MODULE: ./src/services/home/setBrands.ts
var setBrands = __webpack_require__(76784);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/context/MapCordinateContext.tsx
var MapCordinateContext = __webpack_require__(20546);
// EXTERNAL MODULE: ./src/pages/404.tsx + 1 modules
var _404 = __webpack_require__(66115);
;// CONCATENATED MODULE: ./src/components/store-locator/city-component.tsx
/* eslint-disable */ 




var CityLandingComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9238), __webpack_require__.e(4585), __webpack_require__.e(395), __webpack_require__.e(1909), __webpack_require__.e(5675), __webpack_require__.e(6579), __webpack_require__.e(6692)]).then(__webpack_require__.bind(__webpack_require__, 51401));
});







var CityComponent = function(props) {
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var vehicleLandingPage = props.vehicleLandingPage;
    var ref = (0,react.useState)([]), unitsInfo = ref[0], setUnitsInfo = ref[1];
    var ref1 = (0,react.useState)(), cityInfo = ref1[0], setCityInfo = ref1[1];
    var ref2 = (0,react.useState)(null), brandCta = ref2[0], setBrandCta = ref2[1];
    var mapCords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    var ref3 = (0,react.useState)(), ordinate = ref3[0], setOrdinate = ref3[1];
    var locale = (0,next_router.useRouter)().locale;
    var isContext = !!headerFooter[0];
    var ref4 = (0,react.useState)(false), err = ref4[0], setErr = ref4[1];
    var getContextData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var defaultBrand, contextData, brands, Cta;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = constants/* BRAND_NAME_EN */.Vp;
                        if (locale === "fr") defaultBrand = constants/* BRAND_NAME_FR */.Fj;
                        return [
                            4,
                            (0,setBrands/* default */.Z)(defaultBrand, locale)
                        ];
                    case 1:
                        contextData = _state.sent();
                        brands = contextData === null || contextData === void 0 ? void 0 : contextData.data;
                        Cta = brands && brands[0] && brands[0].attributes && brands[0].attributes.CTA_Section;
                        setBrandCta(Cta);
                        headerFooterData.setHeaderFooterData(brands);
                        return [
                            2
                        ];
                }
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        var obj = {
            lat: parseFloat(cityInfo === null || cityInfo === void 0 ? void 0 : (ref = cityInfo.attributes) === null || ref === void 0 ? void 0 : ref.Latitude),
            lng: parseFloat(cityInfo === null || cityInfo === void 0 ? void 0 : (ref1 = cityInfo.attributes) === null || ref1 === void 0 ? void 0 : ref1.Longitude)
        };
        setOrdinate(obj);
        return function() {
            mapCords.setLatLogCity({});
        };
    }, []);
    var getFacilityData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, defaultBrand, slug, cityResult, newArray;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = constants/* BRAND_NAME_EN */.Vp;
                        slug = props === null || props === void 0 ? void 0 : props.city;
                        if (locale === "fr") {
                            defaultBrand = constants/* BRAND_NAME_FR */.Fj;
                            slug = "".concat(props === null || props === void 0 ? void 0 : props.city, "-fr");
                        }
                        return [
                            4,
                            Promise.all([
                                (0,home/* getRightUnitInfo */.Zy)(defaultBrand, locale),
                                vehicleLandingPage ? (0,home/* getVehicleLandingData */.co)(slug, defaultBrand, locale) : (0,home/* getCityLandingInfo */.fC)(slug, defaultBrand, locale)
                            ])
                        ];
                    case 1:
                        cityResult = _state.sent();
                        setUnitsInfo((ref = cityResult[0]) === null || ref === void 0 ? void 0 : ref.data);
                        setCityInfo((ref1 = cityResult[1]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.data[0]);
                        newArray = [
                            {
                                lan: (ref5 = (ref3 = cityResult[1]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.data[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.attributes) === null || ref6 === void 0 ? void 0 : ref6.locale,
                                slugValue: (ref9 = (ref7 = cityResult[1]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.data) === null || ref8 === void 0 ? void 0 : ref8.data[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.attributes) === null || ref10 === void 0 ? void 0 : ref10.Slug
                            },
                            {
                                lan: (ref16 = (ref13 = (ref11 = cityResult[1]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.data) === null || ref12 === void 0 ? void 0 : ref12.data[0]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.attributes) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.localizations) === null || ref15 === void 0 ? void 0 : ref15.data[0]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.attributes) === null || ref17 === void 0 ? void 0 : ref17.locale,
                                slugValue: (ref23 = (ref20 = (ref18 = cityResult[1]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.data) === null || ref19 === void 0 ? void 0 : ref19.data[0]) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.attributes) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.localizations) === null || ref22 === void 0 ? void 0 : ref22.data[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.attributes) === null || ref24 === void 0 ? void 0 : ref24.Slug
                            }
                        ];
                        if (newArray[0].lan) {
                            sessionStorage.setItem("facCords", JSON.stringify(newArray));
                        }
                        if (((ref25 = cityResult[1]) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.data) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.data) === null || ref27 === void 0 ? void 0 : ref27.length) === 0) {
                            setErr(true);
                        } else {
                            setErr(false);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function getFacilityData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getFacilityData();
    }, [
        locale,
        location
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !err && cityInfo && brandCta && unitsInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(CityLandingComponent, {
                cords: ordinate,
                cityLandingInfo: cityInfo,
                ourBrandsData: brandCta,
                bodyData: unitsInfo,
                hostUrl: props === null || props === void 0 ? void 0 : props.hostUrl,
                vehicleLandingPage: vehicleLandingPage
            }),
            err && /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {})
        ]
    });
};
/* harmony default export */ var city_component = (CityComponent);

;// CONCATENATED MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */



;// CONCATENATED MODULE: ./src/components/store-locator/facility-component.tsx
/* eslint-disable */ 




var LocationLanding = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1255), __webpack_require__.e(9238), __webpack_require__.e(4585), __webpack_require__.e(1909), __webpack_require__.e(804), __webpack_require__.e(696), __webpack_require__.e(4544), __webpack_require__.e(3752), __webpack_require__.e(5675), __webpack_require__.e(3022), __webpack_require__.e(5838)]).then(__webpack_require__.bind(__webpack_require__, 24077));
});





var FacilityComponent = function(props) {
    var ref;
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var headerInfo = (ref = headerFooterData === null || headerFooterData === void 0 ? void 0 : headerFooterData.headerFooter[0]) === null || ref === void 0 ? void 0 : ref.attributes;
    var ref1 = (0,react.useState)(null), facilityInfo = ref1[0], setFaciltyInfo = ref1[1];
    var ref2 = (0,react.useState)(null), articleInfo = ref2[0], setArticleInfo = ref2[1];
    var mapCords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    var facilityData = props === null || props === void 0 ? void 0 : props.facilityData;
    var reviewsData = props.reviewsData, unitData = props.unitData, promotions = props.promotions;
    var locale = (0,next_router.useRouter)().locale;
    var isContext = !!headerFooter[0];
    var location = props === null || props === void 0 ? void 0 : props.facility;
    var ref3 = (0,react.useState)(false), err = ref3[0], setErr = ref3[1];
    var getContextData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, brands;
            return (0,tslib_es6.__generator)(this, function(_state) {
                brands = props === null || props === void 0 ? void 0 : (ref = props.brandData) === null || ref === void 0 ? void 0 : ref.data;
                headerFooterData.setHeaderFooterData(brands);
                return [
                    2
                ];
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    var getFacilityData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, matched, ref25, ref26, coords, splicedStr, frSlug, enSlug, split, ref27, facilitySlugResData, ref28, ref29, ref30, ref31, ref32, citySlug, multiFacility, newArray;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (locale === "fr") {
                    if ((props === null || props === void 0 ? void 0 : props.checkQueryLen) === 2) location = "".concat(props === null || props === void 0 ? void 0 : props.facility, "-fr");
                    else location = "".concat(props === null || props === void 0 ? void 0 : props.facility);
                }
                matched = false;
                if (sessionStorage.getItem("facCords")) {
                    ;
                    coords = JSON.parse(sessionStorage.getItem("facCords"));
                    ;
                    frSlug = (ref25 = coords.find(function(e) {
                        return e.lan === "fr";
                    })) === null || ref25 === void 0 ? void 0 : ref25.slugValue;
                    enSlug = (ref26 = coords.find(function(e) {
                        return e.lan === "en";
                    })) === null || ref26 === void 0 ? void 0 : ref26.slugValue;
                    split = frSlug.split("-");
                    splicedStr = split.slice(0, split.length - 1).join("-");
                    if (splicedStr === (props === null || props === void 0 ? void 0 : props.facility) || enSlug === (props === null || props === void 0 ? void 0 : props.facility)) {
                        if ((props === null || props === void 0 ? void 0 : props.checkQueryLen) === 2) matched = true;
                    }
                    if (matched) {
                        ;
                        location = (ref27 = coords.find(function(e) {
                            return e.lan === locale;
                        })) === null || ref27 === void 0 ? void 0 : ref27.slugValue;
                    }
                }
                facilitySlugResData = facilityData;
                // Blog related information based on facility,city or default.
                if ((facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref = facilitySlugResData.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.Blog) === null || ref1 === void 0 ? void 0 : ref1.data) !== null) {
                    setArticleInfo(facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : facilitySlugResData.attributes);
                } else if ((facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref2 = facilitySlugResData.attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Blog) === null || ref3 === void 0 ? void 0 : ref3.data) === null && (facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref4 = facilitySlugResData.attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.City) === null || ref5 === void 0 ? void 0 : ref5.data) !== null && (facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref6 = facilitySlugResData.attributes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.City) === null || ref7 === void 0 ? void 0 : ref7.data.hasOwnProperty("attributes")) && (facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref8 = facilitySlugResData.attributes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.City) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Blog) === null || ref12 === void 0 ? void 0 : ref12.data) !== null) {
                    ;
                    setArticleInfo(facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref28 = facilitySlugResData.attributes) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.City) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.data) === null || ref30 === void 0 ? void 0 : ref30.attributes);
                } else {
                    ;
                    setArticleInfo((ref32 = props === null || props === void 0 ? void 0 : (ref31 = props.brandData) === null || ref31 === void 0 ? void 0 : ref31.data[0]) === null || ref32 === void 0 ? void 0 : ref32.attributes);
                }
                citySlug = facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref13 = facilitySlugResData.attributes) === null || ref13 === void 0 ? void 0 : ref13.City_Slug;
                multiFacility = facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref14 = facilitySlugResData.attributes) === null || ref14 === void 0 ? void 0 : ref14.multiFacility;
                if (facilitySlugResData && Object.keys(facilitySlugResData).length === 0 || multiFacility && citySlug !== (props === null || props === void 0 ? void 0 : props.city) && citySlug != undefined || facilitySlugResData === undefined) {
                    setErr(true);
                } else {
                    setErr(false);
                }
                setFaciltyInfo(facilitySlugResData);
                newArray = [
                    {
                        lan: facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref15 = facilitySlugResData.attributes) === null || ref15 === void 0 ? void 0 : ref15.locale,
                        slugValue: facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref16 = facilitySlugResData.attributes) === null || ref16 === void 0 ? void 0 : ref16.Slug
                    },
                    {
                        lan: (ref19 = facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref17 = facilitySlugResData.attributes) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.localizations) === null || ref18 === void 0 ? void 0 : ref18.data[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.attributes) === null || ref20 === void 0 ? void 0 : ref20.locale,
                        slugValue: (ref23 = facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref21 = facilitySlugResData.attributes) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.localizations) === null || ref22 === void 0 ? void 0 : ref22.data[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.attributes) === null || ref24 === void 0 ? void 0 : ref24.Slug
                    }
                ];
                if (newArray[0].lan && (props === null || props === void 0 ? void 0 : props.checkQueryLen) === 2) {
                    sessionStorage.setItem("facCords", JSON.stringify(newArray));
                    api.set("facCords", JSON.stringify(newArray));
                }
                return [
                    2
                ];
            });
        });
        return function getFacilityData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getFacilityData();
    }, [
        locale,
        location,
        props === null || props === void 0 ? void 0 : props.facilityData
    ]);
    (0,react.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    (0,react.useEffect)(function() {
        return function() {
            mapCords.setLatLog({});
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            facilityInfo && !err && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationLanding, {
                    facilityData: facilityInfo,
                    brandRelatedData: headerInfo,
                    articlesData: articleInfo,
                    reviewsData: reviewsData,
                    unitData: unitData,
                    promotions: promotions || []
                })
            }),
            err && /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {})
        ]
    });
};
/* harmony default export */ var facility_component = (FacilityComponent);

// EXTERNAL MODULE: ./src/components/utility.ts
var utility = __webpack_require__(55088);
;// CONCATENATED MODULE: ./src/pages/self-storage/[...location]/index.tsx












var Location = function(props) {
    var ref, ref1, ref2;
    var query = (0,next_router.useRouter)().query;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(false), facilityPage = ref3[0], setFacilityPage = ref3[1];
    var ref4 = (0,react.useState)(false), cityPage = ref4[0], setCityPage = ref4[1];
    var ref5 = (0,react.useState)(""), facilityName = ref5[0], setFacilityName = ref5[1];
    var ref6 = (0,react.useState)(""), cityName = ref6[0], setCityName = ref6[1];
    var facilityList = props === null || props === void 0 ? void 0 : (ref = props.cityData) === null || ref === void 0 ? void 0 : ref.data;
    var hostUrl = props.hostUrl, vehicleLandingPage = props.vehicleLandingPage, facilityData = props.facilityData, reviewsData = props.reviewsData, facilityInfo = props.facilityInfo, unitsresultsData = props.unitsresultsData, isClientHub = props.isClientHub;
    var ref7 = (0,react.useState)(null), checkQueryLen = ref7[0], setCheckQueryLen = ref7[1];
    var ref8 = (0,react.useState)(false), checkCity = ref8[0], setCheckCity = ref8[1];
    var ref9 = (0,react.useState)(false), error = ref9[0], setError = ref9[1];
    (0,react.useEffect)(function() {
        // Handling 404 errors
        if (query && query.location && query.location.length > 2) {
            setError(true);
        } else if (query && query.location && query.location.length === 2) {
            setCheckQueryLen(query.location.length);
            // For Facility pages(single,two)
            var city = query && query.location && query.location[0];
            var name = query && query.location && query.location[1];
            setFacilityPage(true);
            setCityPage(false);
            setCityName(city);
            setFacilityName(name);
        } else if (query && query.location && query.location.length === 1) {
            // For Vehicle pages
            var name1 = query && query.location && query.location[0];
            if (vehicleLandingPage) {
                setCityPage(true);
                setCityName(name1);
                setFacilityPage(false);
            } else {
                setCheckQueryLen(query.location.length);
                var filterLoc = facilityList.length === 0;
                if (filterLoc) {
                    // For Facility pages
                    setFacilityPage(true);
                    setFacilityName(name1);
                    setCityPage(false);
                } else {
                    // For City pages
                    setCityPage(true);
                    setCityName(name1);
                    setFacilityPage(false);
                }
            }
        }
        if ((facilityList === null || facilityList === void 0 ? void 0 : facilityList.length) === 0) {
            // Boolean value required in facility pages whether single slug or not
            setCheckCity(true);
        } else {
            setCheckCity(false);
        }
    }, [
        query.location,
        facilityList
    ]);
    if (isClientHub === true) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                    noindex: true,
                    nofollow: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(client_hub, {
                    facility: facilityName,
                    facilityData: facilityData
                })
            ]
        });
    }
    var seoInfo = (0,utility/* getSEOProps */.RN)(props === null || props === void 0 ? void 0 : props.seoData, router);
    // Define the canonical URL, which will serve as the @id for schema merging
    var canonicalUrl = (0,utility/* getCanonicalURL */.DN)(router);
    var placeName = (facilityData === null || facilityData === void 0 ? void 0 : (ref1 = facilityData.Address) === null || ref1 === void 0 ? void 0 : ref1.City) || "";
    var areaServedSchema = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "@id": canonicalUrl,
        areaServed: {
            "@type": "Place",
            name: placeName
        }
    };
    var faqStructuredData = (props === null || props === void 0 ? void 0 : props.seoFaqData) && (0,utility/* generateDynamicFAQ */.a4)(props === null || props === void 0 ? void 0 : (ref2 = props.seoFaqData) === null || ref2 === void 0 ? void 0 : ref2.Panel, true);
    var breadCrumbUrlList = (0,utility/* generateDynamicBCLD */.W_)(router);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: placeName && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    // Use dangerouslySetInnerHTML to insert the raw JSON string
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(areaServedSchema)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seoInfo)),
            (props === null || props === void 0 ? void 0 : props.seoFaqData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* FAQPageJsonLd */.Mg, {
                mainEntity: faqStructuredData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Canonical/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                itemListElements: breadCrumbUrlList
            }),
            facilityData && unitsresultsData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* LocalBusinessJsonLd */.wq, (0,_object_spread/* default */.Z)({}, (0,utility/* generateLocalBusinessStructerData */.u3)(facilityData, unitsresultsData, reviewsData, router)))
            }),
            facilityPage && facilityName && facilityName.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facility_component, {
                    facility: facilityName,
                    facilityData: facilityInfo,
                    checkCity: checkCity,
                    city: cityName,
                    reviewsData: reviewsData,
                    unitData: unitsresultsData,
                    checkQueryLen: checkQueryLen,
                    brandData: props === null || props === void 0 ? void 0 : props.contextData,
                    promotions: props === null || props === void 0 ? void 0 : props.promotions
                })
            }),
            cityPage && cityName && cityName.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(city_component, {
                city: cityName,
                hostUrl: hostUrl,
                vehicleLandingPage: vehicleLandingPage,
                brandData: props === null || props === void 0 ? void 0 : props.contextData
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _location_ = (Location);


/***/ }),

/***/ 66156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ getConvenientLocations; },
/* harmony export */   "YW": function() { return /* binding */ getHeaderAndFooterDetailsWithDefaultLocale; },
/* harmony export */   "Zy": function() { return /* binding */ getRightUnitInfo; },
/* harmony export */   "co": function() { return /* binding */ getVehicleLandingData; },
/* harmony export */   "fC": function() { return /* binding */ getCityLandingInfo; },
/* harmony export */   "fU": function() { return /* binding */ getInnerPagesWithDefaultLocale; },
/* harmony export */   "k5": function() { return /* binding */ getBrandReviews; },
/* harmony export */   "ns": function() { return /* binding */ getGoogleReviews; },
/* harmony export */   "zc": function() { return /* binding */ getOurBrands; }
/* harmony export */ });
/* unused harmony exports getGoogleReview, getHomeBodyDetailsWithDefaultLocale, getStudentSpecialContent, getValidityCity */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15122);
/* harmony import */ var _apiUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33891);




var getHeaderAndFooterDetailsWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var data = (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getBrandLocaleUrl */ .oo(brand, locale)), "get");
                        resolve(data);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function getHeaderAndFooterDetailsWithDefaultLocale() {
        return _ref.apply(this, arguments);
    };
}();
var getHomeBodyDetailsWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var data = (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getHomeLocaleUrl */ .dK(brand, locale)), "get");
                        resolve(data);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function getHomeBodyDetailsWithDefaultLocale() {
        return _ref.apply(this, arguments);
    };
}();
var getBrandReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .GOOGLE_CLIENT_REVIEWS */ .Zk), "get")
            ];
        });
    });
    return function getBrandReviews() {
        return _ref.apply(this, arguments);
    };
}();
var getOurBrands = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .GET_OUR_BRANDS */ .e), "get")
            ];
        });
    });
    return function getOurBrands() {
        return _ref.apply(this, arguments);
    };
}();
// for future lcode include
var getGoogleReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getClientReviews */ .Vf(lcode)), "get")
            ];
        });
    });
    return function getGoogleReviews(lcode) {
        return _ref.apply(this, arguments);
    };
}();
var getGoogleReview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode, locale) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getClientReview */ .tw(lcode, locale)), "get")
            ];
        });
    });
    return function getGoogleReview(lcode, locale) {
        return _ref.apply(this, arguments);
    };
}();
// lat, lng, brand, limit,
var getConvenientLocations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lang, cords) {
        var ncards;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            ncards = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 3;
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .CONVENIENT_LOCATIONS */ .vi, "?lat=").concat(cords === null || cords === void 0 ? void 0 : cords.latitude, "&lng=").concat(cords === null || cords === void 0 ? void 0 : cords.longitude, "&brand=as&limit=").concat(ncards, "&lang=").concat(lang), "get")
            ];
        });
    });
    return function getConvenientLocations(lang, cords) {
        return _ref.apply(this, arguments);
    };
}();
// brand section
var getInnerPagesWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(innerPageName) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getInnerPagesUrl */ .zP(innerPageName, brand, locale)), "get")
            ];
        });
    });
    return function getInnerPagesWithDefaultLocale(innerPageName) {
        return _ref.apply(this, arguments);
    };
}();
// student special content
var getStudentSpecialContent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(defaultLink, locale, brand) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getStudentSpecialUrl */ .Sh(defaultLink, locale, brand)), "get")
            ];
        });
    });
    return function getStudentSpecialContent(defaultLink, locale, brand) {
        return _ref.apply(this, arguments);
    };
}();
// city landing page
var getCityLandingInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getCityLandingInfo */ .fC(slug, brand, locale)), "get")
            ];
        });
    });
    return function getCityLandingInfo(slug) {
        return _ref.apply(this, arguments);
    };
}();
// city landing page
var getVehicleLandingData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getVehicleLandingInfo */ .CZ(slug, brand, locale)), "get")
            ];
        });
    });
    return function getVehicleLandingData(slug) {
        return _ref.apply(this, arguments);
    };
}();
// right units
var getRightUnitInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getRightUnitInfo */ .Zy(brand, locale)), "get")
            ];
        });
    });
    return function getRightUnitInfo() {
        return _ref.apply(this, arguments);
    };
}();
// validate city for facility slug
var getValidityCity = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug, brand) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getValidateCity */ .e$(slug, brand)), "get")
            ];
        });
    });
    return function getValidityCity(slug, brand) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 76784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);



var SetBrandsContext = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var brand, locale, ref, result, data;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "dp", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
                    return [
                        4,
                        Promise.all([
                            (0,___WEBPACK_IMPORTED_MODULE_0__/* .getHeaderAndFooterDetailsWithDefaultLocale */ .YW)(brand, locale)
                        ])
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        (ref = result[0]) === null || ref === void 0 ? void 0 : ref.data
                    ];
                case 2:
                    data = _state.sent() || null;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function SetBrandsContext() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (SetBrandsContext);


/***/ }),

/***/ 39076:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"howToGetRewardContainer":"style_howToGetRewardContainer__JzsF1","howToGetRewardContent":"style_howToGetRewardContent__o2vei","howToGetRewardContentItem":"style_howToGetRewardContentItem__QXi4n","howToGetRewardContentItemImg":"style_howToGetRewardContentItemImg__CMTtg","howToGetRewardContentItemTitle":"style_howToGetRewardContentItemTitle__qk4fL","howToGetRewardContentItemText":"style_howToGetRewardContentItemText__HsSOt","rewardAmount":"style_rewardAmount__bMpfx","rowTitleContainer":"style_rowTitleContainer__aJxEx","rowTitle":"style_rowTitle__iipgZ","rewardItems":"style_rewardItems__nw9L2","rewardAmountItem":"style_rewardAmountItem__i5cKv","rewardAmountItemCircle":"style_rewardAmountItemCircle__U5Mfo","rewardAmountItemCircleText":"style_rewardAmountItemCircleText__jlBn3","rewardAmountItemTitle":"style_rewardAmountItemTitle__4Lamv","rewardAmountItemText":"style_rewardAmountItemText__WAGbD","rewardSection":"style_rewardSection__cN3vJ","RecentWinnersContainer":"style_RecentWinnersContainer__XfXJP","RecentWinnersRow":"style_RecentWinnersRow__0IcmZ","RecentWinnersCount":"style_RecentWinnersCount__VAxSx","RecentWinnersCountText":"style_RecentWinnersCountText__lmoIf","RecentWinnersNames":"style_RecentWinnersNames__nDzIL","RecentWinnersNamesTitle":"style_RecentWinnersNamesTitle__DM1H0","RecentWinnersNamesItems":"style_RecentWinnersNamesItems__ZvABy","referralForm":"style_referralForm__EeN5c","referralFormFields":"style_referralFormFields___SSKm","referralFormLeft":"style_referralFormLeft__iVusH","referralFormRight":"style_referralFormRight__XfnLp","formRow":"style_formRow___NISA","formLabel":"style_formLabel__34i5U","formInput":"style_formInput__p7IWC","formBtnRow":"style_formBtnRow__u0wtw","formSubmitBtn":"style_formSubmitBtn__eWERa","formRowConsent":"style_formRowConsent__7fxJW","formRowConsentCheckBox":"style_formRowConsentCheckBox__MLpBd","cardComponentContainer":"style_cardComponentContainer__uqoY_","cardComponentContentTitle":"style_cardComponentContentTitle__V1vOD","referralPolicyContainer":"style_referralPolicyContainer__JLQRt","referralPolicyRow":"style_referralPolicyRow__Dgu8e","referralPolicyContent":"style_referralPolicyContent__L6o8A","referralBottomSection":"style_referralBottomSection__920TP","whomYouCanReferContainer":"style_whomYouCanReferContainer__crnmP","whomYouCanReferRow":"style_whomYouCanReferRow__FJ769","referralCardContainer":"style_referralCardContainer__qvxW6","referralCardLeftContainer":"style_referralCardLeftContainer__QNxbt","referralCardLogoContainer":"style_referralCardLogoContainer__9_E5s","referralCardLogo":"style_referralCardLogo___EXqf","referralCardLogoImage":"style_referralCardLogoImage__5YW_U","referralCardTitle":"style_referralCardTitle__qPn2T","referralCardLeftContainerTitleContainer":"style_referralCardLeftContainerTitleContainer__xPvKc","referralCardLeftContainerTitle":"style_referralCardLeftContainerTitle__OEgpg","referralCardLeftContainerText":"style_referralCardLeftContainerText__B7b_r","referralCardRightContainer":"style_referralCardRightContainer__XPALZ","referralCardRightContainerTopContainer":"style_referralCardRightContainerTopContainer__4X9B0","referralCardRightContainerTopContainerNameContainer":"style_referralCardRightContainerTopContainerNameContainer__LLyd5","referralCardRightContainerTopContainerNameContainerTile":"style_referralCardRightContainerTopContainerNameContainerTile__pnCjm","referralCardRightContainerTopContainerNameContainerName":"style_referralCardRightContainerTopContainerNameContainerName__dli7s","referralCardRightContainerBottomContainer":"style_referralCardRightContainerBottomContainer__ILQ1R","referralCardRightContainerBottomContainerText":"style_referralCardRightContainerBottomContainerText__i4bl3","referralPopUp":"style_referralPopUp__5Oj5U","referralPopUpContainer":"style_referralPopUpContainer__ZEr_l","referralPopUpInnerContainer":"style_referralPopUpInnerContainer___9Jpq","formInputContainer":"style_formInputContainer__LkxQe","RecentWinnersCountNumberImage":"style_RecentWinnersCountNumberImage__r4YE2","howToGetRewardContentItemReveres":"style_howToGetRewardContentItemReveres__IOky_","howToGetRewardContentImage":"style_howToGetRewardContentImage__ZS1oz","howToGetRewardTextContent":"style_howToGetRewardTextContent__sOj5t","cardComponentContentImage":"style_cardComponentContentImage____wYJ","cardComponentContentText":"style_cardComponentContentText__dWfTK"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,1217,1608,1664,7536,2223,606,5775,3640,7431,9774,2888,179], function() { return __webpack_exec__(12802); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);